import config from '@/config'
import HttpClient from '@/api/http/client'
import ResponseError from '@/api/http/ResponseError'
import NewResponseError from '@/api/http/NewResponseError'

const http = new HttpClient(config.integrationACL.baseUrl)

export default {
  async createPlayHubSubscription(accountId, code) {
    const accessToken = ''
    const response = await http.sendRequest('/v1/subscriptions', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        accountUUID: accountId,
        subscriberCode: code
      })
    })

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async searchIsp(ispName) {
    try {
      if (ispName.length >= 3) {
        const response = await http.sendRequest('/v1/playhub/isp', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Accept-Encoding': 'gzip, deflate, br'
          },
          body: JSON.stringify({
            Filtro: ispName
          })
        })
        this.isps = await response.json()
        return this.isps.Nomes
      } else {
        this.isps = []
        return this.isps
      }
    } catch (error) {
      throw new ResponseError(error.status)
    }
  },
  async unlockAccount(ispName, login, password) {
    const responseValidation = await http.sendRequest('/v1/playhub/login/check', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Accept-Encoding': 'gzip, deflate, br'
      },
      body: JSON.stringify({
        Isp: ispName,
        Login: login,
        Senha: password
      })
    })

    if (!responseValidation.ok) {
      const errorResponse = await responseValidation.json()
      throw new NewResponseError(responseValidation.status, errorResponse)
    }

    const resultValidation = await responseValidation.json()

    if (resultValidation.ExternalId && resultValidation.PlanId) {
      const responseCheck = await http.sendRequest('/v1/playhub/externalid/check', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Accept-Encoding': 'gzip, deflate, br'
        },
        body: JSON.stringify({
          ExternalId: resultValidation.ExternalId,
          PlanId: resultValidation.PlanId,
          Login: login
        })
      })

      if (!responseCheck.ok) {
        const errorResponse = await responseCheck.json()
        throw new NewResponseError(responseCheck.status, errorResponse)
      }

      const resultCheck = await responseCheck.json()
      return { resultValidation, resultCheck, responseValidation, responseCheck }
    }
  },
  async activateExternalId(externalId, planId, accountId, login) {
    const response = await http.sendRequest('/v1/playhub/externalid/activate', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Accept-Encoding': 'gzip, deflate, br'
      },
      body: JSON.stringify({
        ExternalId: externalId,
        PlanId: planId,
        UserId: accountId,
        Login: login
      })
    })
    if (response.ok) {
      const data = await response.json()
      return data
    } else {
      const errorResponse = await response.json()
      throw new NewResponseError(response.status, errorResponse)
    }
  }
}
